import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh', // Centers vertically in the viewport
          textAlign: 'center',
          px: 3,
        }}
      >
        <Typography 
          variant="h1" 
          sx={{ fontSize: { xs: '5rem', md: '8rem' }, fontWeight: 'bold', color: 'primary.main' }}
        >
          404
        </Typography>

        <Typography 
          variant="h4" 
          component="h2" 
          gutterBottom
          sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}
        >
          Oops! Page not found 🕵️‍♂️
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          The page you’re looking for doesn’t exist or has been moved. 
          Don't worry, it happens to the best of us.
        </Typography>

        <Button
          variant="contained"
          component={RouterLink}
          to="/"
          size="large"
          startIcon={<ErrorOutlineIcon />}
          sx={{ borderRadius: 2, textTransform: 'none' }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;